<template>
  <div>
        <pt-form-list-item v-if="this.fromPage === 'batch'">
            <div :class="$style['customer-batch-grant-amount-text']">
              请您确保所选记录奖励发放金额正确，并谨慎使用批量功能
            </div>
        </pt-form-list-item>
    <table :class="$style['customer-grant-form']">
      <pt-form-list-item label="事业部归属：" required>
        <wt-selector :options="businessDepartments" :props="{label:'name',value:'id'}" v-model="form.businessDepartmentId" data-vv-as="事业部"
                     name="type"  v-validate="'required'" :loading="departmentLoading" ></wt-selector>
      </pt-form-list-item>
        <pt-form-list-item label="奖励类别:" v-if="fromType==='manual'" required>
            <wt-selector v-model="form.businessType" :options="bussinessTypes" :allow-create="true" :props="bussinessTypeProps" :loading="bussinessTypeLoading"
                   filterable :defaultFirstOption="false"  :clearable="true" placeholder="请输入或选择" @visible-change="visibleChange"  v-validate="'required'" data-vv-as="奖励类别" name="type"></wt-selector>
        </pt-form-list-item>
       <pt-form-list-item label="返现金额："  v-if="isShowAmountInput" :widthMax="maxWidth">
            <div :class="$style['customer-grant-amount-div']">
              <wt-input v-model="form.amount" :disabled="isFinancial" placeholder="请输入返现金额" data-vv-as="返现金额" type="number" v-validate="'decimal:2|min_value:0'" :class="$style['customer-grant-amount']">
                <el-button slot="append">元</el-button>
              </wt-input>
            <span :class="$style['customer-grant-amount-text']">返现至用户钱包余额</span></div>
        </pt-form-list-item>
       <pt-form-list-item label="返现积分："  v-else :widthMax="maxWidth">
            <div :class="$style['customer-grant-amount-div']">
              <wt-input v-model="form.amount" placeholder="请输入返现积分" data-vv-as="返现积分" type="number" v-validate="'decimal:2|min_value:0'" :class="$style['customer-grant-amount']">
                <el-button slot="append">分</el-button>
              </wt-input>
            </div>
        </pt-form-list-item>
        <pt-form-list-item label="优惠劵：" v-if="fromType !== 'integral' && !hasFinancial">
          <el-button type="primary" plain @click="selectCoupons">添加优惠劵</el-button>
        </pt-form-list-item>
        <pt-form-list-item label="已选择：" v-if="fromType !== 'integral' && !hasFinancial">
          <div :class="$style['selected-coupon']">
            <template v-if="coupon_list.length>0">
              <wt-table :list="coupon_list">
                  <template>
                      <el-table-column label="优惠劵:">
                          <template slot-scope="scope">
                              {{scope.row.couponData&&scope.row.couponData.name}}
                          </template>
                      </el-table-column>
                      <el-table-column label="优惠劵内容">
                          <template slot-scope="scope">
                              <div>{{scope.row.discount}}</div>
                              <div>满{{scope.row.thresholdOfAmount}}元可使用</div>
                          </template>
                      </el-table-column>
                      <!-- <el-table-column label="剩余库存（张）">
                          <template slot-scope="scope">
                              {{scope.row.surplusAmount}}
                          </template>
                      </el-table-column> -->
                      <el-table-column label="赠券张数">
                          <template slot-scope="scope">
                              <wt-input v-model="scope.row.amount" data-vv-as="赠券张数" type="number" v-validate="'gtezero'"></wt-input>
                          </template>
                      </el-table-column>
                      <el-table-column label="操作">
                          <template slot-scope="scope">
                          <el-button type="text" @click="deleteCoupon(scope.row)">删除</el-button>
                      </template>
                      </el-table-column>
                  </template>
              </wt-table>
             </template>
             <template v-else>未选择任何优惠劵</template>
          </div>
        </pt-form-list-item>
    </table>
 <el-dialog :visible="is_dialog"  :title="dialog_title" @close="closeDialog" :class="$style['coupon-select-dialog']">
   <coupon-list v-if="is_select_coupon" @selectCouponSubmit="selectCouponSubmit" :couponParams="couponParams"  @close="closeDialog" :selected-coupon="coupon_list"></coupon-list>
 </el-dialog>
  </div>
</template>
<script>
import formMixins from 'mixins/form'
import couponList from '../../pt-promotion-coupon/coupon-list'
import { hasPermissions } from 'utils/permissions'

export default {
  mixins: [formMixins],
  components: {
    couponList
  },
  data () {
    return {
      form: {
        amount: (this.fromType !== 'manual' && (this.customerType === 'old' ? 100 : (this.customerType === 'new' ? 500 : null))) || null
      },
      coupon_list: [],
      is_select_coupon: false,
      dialog_title: '',
      couponParams: {
        discountType: 'FIXED_AMOUNT'
      },
      bussinessTypeProps: {
        value: 'value',
        label: 'name'
      }
    }
  },
  props: {
    fromPage: {
      type: String,
      default: null
    },
    maxWidth: {
      type: Number,
      default: null
    },
    bussinessTypes: {
      type: Array,
      default: function () {
        return []
      }
    },
    fromType: {
      type: String,
      default: null
    },
    bussinessTypeLoading: {
      type: Boolean,
      default: false
    },
    customerType: {
      type: String,
      default: null
    },
    isFinancial: {
      type: Boolean,
      default: false
    },
    businessDepartments: {
      type: Array
    },
    departmentLoading: Boolean
  },
  computed: {
    is_dialog: {
      set: function (val) {
        this.is_select_coupon = val
      },
      get: function () {
        return this.is_select_coupon
      }
    },
    isShowAmountInput () {
      return this.fromPage !== 'batch' && this.fromType !== 'integral'
    },
    hasFinancial () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_FINANCIAL_REWARD')
    }
  },
  watch: {
    form: {
      handler: function (val) {
        this.$emit('input', val)
      },
      immediate: true
    },
    'form.businessType' (val) {
      this.$emit('changeBusinessType', val)
    }
  },
  methods: {
    visibleChange () {
      this.$emit('getRewardBusinessType')
    },
    selectCoupons () {
      this.is_select_coupon = true
      this.dialog_title = '选择优惠劵'
    },
    closeDialog () {
      this.is_dialog = false
    },
    selectCouponSubmit (val) {
      this.is_dialog = false
      this.coupon_list = JSON.parse(JSON.stringify(val))
      this.$set(this.form, 'discountCoupons', this.coupon_list)
    },
    deleteCoupon (row) {
      this.coupon_list.forEach((item, index) => {
        if (item.id === row.id) {
          this.coupon_list.splice(index, 1)
        }
      })
    }
  },
  created () {
    if (this.hasFinancial) {
      this.form.businessType = '推广奖励'
    }
  }
}
</script>
<style module lang="less">
.customer-grant-form{
  padding: 0 20px;
}
.customer-grant-amount{
  max-width:300px;
  margin-right: 30px;
}
.customer-grant-amount-div{
  display: flex;
  .customer-grant-amount-text{
    line-height: 40px;
    color: #606060
  }
}
.customer-batch-grant-amount-text{
  color: red;
  padding:0 10px
}
.selected-coupon{
  padding: 20px;
  background-color: #F9F9F9;
  :global
  .wt-table{
    *{
      background-color: #F9F9F9;
      .el-input{
        *{
        background-color: #fff;

        }
      }
    }
  }
}
.coupon-select-dialog{
  :global
  .el-dialog{
    min-width: 800PX;
  }
}
</style>
